{
  "title": "Gerenciar Motoristas",
  "statusUpdated": "Status do motorista atualizado com sucesso",
  "invitationSent": "Convite enviado com sucesso",
  "resendSuccess": "Convite reenviado com sucesso",
  "search": "Buscar",
  "loading": "Carregando motoristas...",
  "name": "Nome",
  "email": "E-mail",
  "status": "Status",
  "vehiclesColumn": "Veículos",
  "actions": "Ações",
  "deactivate": "Desativar",
  "activate": "Ativar",
  "invitations": "Convites",
  "inviteNewDriver": "Convidar Motorista",
  "loadingInvitations": "Carregando convites...",
  "noInvitations": "Nenhum convite pendente.",
  "invitePending": "Convite pendente.",
  "resend": "Reenviar",
  "of": "de",
  "statusLabels": {
    "active": "Ativo",
    "inactive": "Inativo",
    "new": "Novo",
    "deactivated": "Desativado",
    "covered": "Cobertura ativa",
    "awaitingCoverage": "Aguardando cobertura",
    "awaitingLicense": "Aguardando licença",
    "associated": "Associado",
    "pending": "Pendente",
    "invited": "Convidado"
  },
  "statusTabs": {
    "all": "Todos",
    "archived": "Inativo"
  },
  "funding": {
    "company": "Empresa paga",
    "self": "Licença própria",
    "ambiguous": "Por confirmar",
    "uncovered": "Sem cobertura",
    "hidden": "Ocultos",
    "covered": "Cobertura ativa",
    "awaiting": "Aguardando cobertura",
    "notCovered": "Sem cobertura ativa",
    "associated": "Associado à empresa",
    "deactivated": "Associação desativada",
    "relationship": "Estado do vínculo",
    "summaryTitle": "Licença e pagamento",
    "relationshipLabel": "Vínculo com a empresa",
    "payerLabel": "Licença paga por",
    "coverageLabel": "Cobertura",
    "personalCoverageLabel": "Cobertura própria",
    "companyCoverageLabel": "Cobertura da empresa",
    "corporateSeatUseLabel": "Uso das vagas da empresa",
    "relationshipStates": {
      "active": "Ativo",
      "associated": "Associado à empresa",
      "pending": "Pendente",
      "deactivated": "Desativado",
      "unknown": "Desconhecido"
    },
    "payers": {
      "company": "Empresa",
      "self": "Motorista (self-pay)",
      "ambiguous": "Por confirmar",
      "uncovered": "Sem pagador ativo",
      "unknown": "Desconhecido"
    },
    "compactStatuses": {
      "active": "Ativo",
      "awaiting": "Aguardando licença",
      "pending": "Pendente",
      "deactivated": "Desativado",
      "notCovered": "Sem licença ativa",
      "associated": "Associado",
      "unknown": "Desconhecido"
    },
    "compactPayers": {
      "company": "Empresa paga",
      "self": "Self-pay",
      "ambiguous": "A confirmar",
      "uncovered": "Sem pagador ativo",
      "unknown": "Desconhecido"
    },
    "coverageStates": {
      "active": "Ativa",
      "awaiting": "Aguardando cobertura",
      "not_covered": "Sem cobertura ativa",
      "unknown": "Desconhecida"
    },
    "corporateSeatUse": {
      "self": "0 — licença própria; não usa vaga da empresa",
      "none": "0 — não usa vaga da empresa",
      "company_one": "{{count}} vaga da empresa",
      "company_other": "{{count}} vagas da empresa",
      "ambiguous": "{{count}} — a confirmar; incluída no uso da empresa",
      "uncovered": "0 — sem cobertura ativa",
      "unknown": "Desconhecido"
    },
    "licenseIssues": {
      "paymentOverdue": "Pagamento em atraso",
      "canceledNonpayment": "Cancelada — pagamento falhou",
      "paymentOverdueAction": "{{name}} não consegue registrar trabalho até o pagamento ser regularizado. Peça para atualizar a forma de pagamento, ou envie um novo convite pago pela empresa em Motoristas.",
      "canceledNonpaymentAction": "{{name}} não consegue mais registrar trabalho. Peça para ativar uma nova licença, ou envie um novo convite pago pela empresa em Motoristas.",
      "thisDriver": "Este motorista"
    }
  },
  "filters": {
    "title": "Filtros",
    "search": "Buscar",
    "status": "Status do vínculo",
    "payer": "Licença paga por",
    "visibility": "Visibilidade nos relatórios",
    "showHidden": "Mostrar motoristas ocultos dos relatórios",
    "showMore": "Mais filtros",
    "showFewer": "Menos filtros",
    "needsAttention": "Requer atenção",
    "dataToConfirm": "Dados a confirmar",
    "noActiveLicense": "Sem licença ativa",
    "sort": "Ordenar por",
    "licensePaymentIssue": "Pagamento da licença falhou"
  },
  "newest": "Mais Recente",
  "oldest": "Mais Antigo",
  "az": "A-Z",
  "za": "Z-A",
  "sortByDate": "Data",
  "sortByName": "Nome",
  "sortLabel": "Ordenar por",
  "noResults": "Sem resultados",
  "page": "Página",
  "showing": "Mostrando",
  "drivers": "motoristas",
  "registrationDate": "Registro",
  "activated": "Ativado",
  "deactivated": "Desativado",
  "common": {
    "all": "Todos",
    "status": "Status",
    "previous": "Anterior",
    "next": "Próximo",
    "ok": "OK",
    "cancel": "Cancelar"
  },
  "ownerDashboard": {
    "inviteDriver": "Convidar Motorista"
  },
  "error": "Erro",
  "errorFetchingDrivers": "Erro ao buscar motoristas",
  "errorUpdatingStatus": "Erro ao atualizar o status do motorista",
  "errorSendingInvitation": "Erro ao enviar convite",
  "errorResendingInvitation": "Erro ao reenviar convite",
  "errorFetchingInvitations": "Erro ao buscar convites",
  "errorCancelingInvitation": "Erro ao cancelar convite",
  "noDriversFound": "Nenhum motorista encontrado",
  "invitationsPending": "pendentes",
  "expired": "Expirado",
  "expiresToday": "Expira hoje",
  "expiresTomorrow": "Expira amanhã",
  "expiresInDays": "Expira em {{days}} dias",
  "expiresAt": "Expira em",
  "pending": "Pendente",
  "workStartDate": "Data de início de trabalho",
  "driverDetailsTitle": "Detalhes do Motorista",
  "driverDetails": {
    "personalInfo": "Informações Pessoais",
    "employmentInfo": "Informações de Emprego",
    "phoneNumber": "Número de Telefone",
    "address": "Endereço",
    "licenseNumber": "CMTVDE",
    "workStartDate": "Data de Início da Prestação do Trabalho",
    "startDate": "Data de Início na Empresa",
    "status": "Status",
    "updatingStatus": "Atualizando status...",
    "emailVerified": "O e-mail está verificado. Não pode ser alterado.",
    "emailUnverified": "O e-mail não está verificado. Você pode alterá-lo, mas será necessária verificação.",
    "reportExportTitle": "Relatório semanal de horas",
    "reportExportDescription": "Exporte o relatório semanal de horas do motorista selecionado em PDF. A data de início da semana usa a segunda-feira atual por padrão.",
    "weekStart": "Início da semana",
    "exportHoursReportPdf": "Exportar relatório de horas (PDF)",
    "exportError": "Erro ao exportar o relatório semanal de horas.",
    "exportShareUnavailable": "O compartilhamento não está disponível neste dispositivo.",
    "shareReportTitle": "Compartilhar relatório semanal de horas",
    "reportHidden": "Oculto dos relatórios da empresa",
    "reportHiddenDescription": "É reversível. Motoristas ocultos exigem inclusão explícita nas exportações.",
    "hiddenExportIncluded": "Esta exportação incluirá explicitamente o motorista oculto.",
    "reportHiddenError": "Erro ao atualizar a visibilidade nos relatórios.",
    "relationshipControlTitle": "Vínculo com a empresa",
    "relationshipActivationLabel": "Ativação pela empresa",
    "selfPaySummary": "Paga pelo motorista · Sem vaga da empresa"
  },
  "vehicles": {
    "allVehicles": "Todos os Veículos",
    "allDrivers": "Todos os Motoristas",
    "searchVehicles": "Buscar por placa, marca, modelo ou ano...",
    "searchDrivers": "Buscar motoristas...",
    "assignedTo": "Atribuído a:",
    "assignedVehicles": "Veículos atribuídos:",
    "assigned": "Atribuído",
    "dropHereToAssign": "Solte aqui para atribuir!",
    "dragToAssign": "Arraste para atribuir ou solte aqui",
    "selectVehicle": "Selecione um veículo para atribuir",
    "assignToDriver": "Atribuir ao Motorista",
    "unassignFromDriver": "Desatribuir",
    "editVehicle": "Editar Veículo",
    "addVehicle": "Adicionar Veículo",
    "vehicleAssigned": "Veículo atribuído com sucesso",
    "vehicleUnassigned": "Veículo desatribuído com sucesso",
    "vehicleCreated": "Veículo criado com sucesso",
    "vehicleUpdated": "Veículo atualizado com sucesso",
    "errorAssigningVehicle": "Erro ao atribuir veículo",
    "errorUnassigningVehicle": "Erro ao desatribuir veículo",
    "errorSavingVehicle": "Erro ao salvar veículo",
    "vehicleAlreadyExistsInCompany": "Este veículo já pertence à sua empresa.",
    "vehicleAssociatedWithCompany": "Veículo foi associado à sua empresa.",
    "errorAssociatingVehicle": "Erro ao associar veículo à empresa.",
    "registrationNumberError": "Formato de número de registro inválido.",
    "noVehiclesSelected": "Nenhum veículo selecionado",
    "assignmentMethods": "Métodos de Atribuição:",
    "dragInstructions": "Para atribuir, arraste o cartão do veículo para o do motorista (ou vice-versa). Como alternativa, clique no cartão para selecioná-lo e depois clique em 'Associar'.",
    "assignSelected": "Atribuir Selecionados",
    "previous": "Anterior",
    "next": "Próximo",
    "registrationNumber": "Número de Registro",
    "make": "Marca",
    "model": "Modelo",
    "year": "Ano",
    "fuelType": "Tipo de Combustível",
    "dragToAssignDriver": "💡 Arraste para atribuir ou solte um motorista aqui",
    "dragToAssignVehicle": "💡 Arraste para atribuir ou solte um veículo aqui",
    "noVehicles": "Nenhum veículo adicionado ainda.",
    "addFirstVehicle": "Adicionar Primeiro Veículo",
    "moreVehicles": "+{count} veículos a mais",
    "assignAVehicle": "Atribuir um Veículo",
    "update": "Atualizar",
    "create": "Criar",
    "manageVehicles": "Gerenciar Veículos",
    "totalVehicles": "Veículos",
    "unassigned": "Não atribuídos",
    "availableVehicles": "Veículos Disponíveis",
    "noVehiclesMatchSearch": "Nenhum veículo corresponde à sua pesquisa",
    "allVehiclesAssigned": "Todos os veículos estão atribuídos a este motorista",
    "assign": "Atribuir",
    "assignVehicles": "Atribuir Veículos",
    "selected": "selecionado",
    "select": "Selecionar",
    "noVehiclesFound": "Nenhum veículo encontrado que corresponda à sua busca",
    "noAvailableVehicles": "Nenhum veículo disponível para atribuir",
    "noDetails": "Sem detalhes adicionais",
    "selectAtLeastOne": "Por favor, selecione pelo menos um veículo",
    "loadError": "Não foi possível carregar os veículos",
    "assignError": "Erro ao atribuir veículos",
    "noAssignedVehicles": "Nenhum veículo atribuído",
    "delete": "Excluir",
    "remove": "Remover",
    "confirmRemove": "Remover Veículo da Empresa",
    "removeMessage": "Tem certeza de que deseja remover o veículo {{registration}} da sua empresa? O veículo permanecerá no banco de dados, mas não estará mais associado à sua empresa.",
    "vehicleRemoved": "Veículo removido da empresa com sucesso",
    "errorRemovingVehicle": "Erro ao remover veículo da empresa"
  },
  "transfers": {
    "title": "Solicitações de Transferência",
    "pendingTransfers": "Transferências Pendentes",
    "loading": "Carregando transferências...",
    "noRequests": "Sem solicitações pendentes",
    "approve": "Aprovar",
    "reject": "Rejeitar",
    "approveSuccess": "Transferência aprovada com sucesso",
    "rejectSuccess": "Transferência rejeitada",
    "errorApproving": "Erro ao aprovar transferência",
    "errorRejecting": "Erro ao rejeitar transferência",
    "errorFetching": "Erro ao carregar transferências",
    "driverInfo": "Informações do Motorista",
    "currentCompany": "Empresa Atual",
    "reason": "Motivo",
    "requestedAt": "Solicitado em",
    "confirmApprove": "Confirmar Aprovação",
    "confirmReject": "Confirmar Rejeição",
    "approveMessage": "Tem certeza de que deseja aprovar a transferência de {{name}}? O motorista será automaticamente transferido para a sua empresa.",
    "rejectMessage": "Tem certeza de que deseja rejeitar a transferência de {{name}}?",
    "confirm": "Confirmar",
    "cancel": "Cancelar",
    "from": "De",
    "status": {
      "pending": "Pendente",
      "approved": "Aprovado",
      "rejected": "Rejeitado"
    }
  },
  "bulkActions": {
    "selected": "Selecionados: {{count}}",
    "selectAll": "Selecionar Todos",
    "transfer": "Transferir",
    "activate": "Ativar",
    "transferDrivers": "Transferir {{count}} Motoristas",
    "transferDriversDescription": "Selecione a empresa de destino para transferir os motoristas selecionados.",
    "transferResult": "Transferidos {{success}} motorista(s). {{errors}} erro(s).",
    "transferError": "Erro ao transferir motoristas: {{error}}",
    "transferLicenseError": "A empresa de destino não tem licenças de motoristas disponíveis.",
    "activateResult": "Ativados {{success}} motorista(s). {{errors}} erro(s).",
    "activateError": "Erro ao ativar motoristas: {{error}}",
    "noInactiveDrivers": "Nenhum motorista inativo selecionado",
    "noDriversSelected": "Nenhum motorista selecionado",
    "result": "Resultado da Operação",
    "licenseErrors": "Problemas de licença:\n{{errors}}",
    "buyLicensesHint": "Por favor, compre licenças adicionais para ativar mais motoristas. Vá para a página de assinatura para comprar mais licenças.",
    "licenseError": "Você precisa comprar licenças para ativar motoristas.",
    "licenseErrorTitle": "Licenças Necessárias",
    "licenseErrorDescription": "Para ativar este motorista, você precisa comprar licenças de motorista adicionais. Clique no botão abaixo para ir para a página de gerenciamento de licenças.",
    "goToLicenses": "Ir para Licenças"
  },
  "transfer": {
    "alsoTransferVehicles": "Também transferir {{count}} veículos relacionados",
    "alsoTransferDrivers": "Também transferir {{count}} motoristas relacionados",
    "selectCompany": "Por favor, selecione uma empresa de destino",
    "error": "Erro ao transferir",
    "noOtherCompanies": "Você precisa de pelo menos uma outra empresa para transferir.",
    "errorLoadingCompanies": "Erro ao carregar empresas",
    "transferButton": "Transferir",
    "licenseError": "A empresa de destino não tem licenças de motoristas disponíveis."
  }
}
